import { createContext, useContext, useEffect, useState } from "react";
import { account } from "../appwrite/config";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const loggedUser = await account.get();

      const userRole = loggedUser.labels?.[0] || "";

      const jwt = await account.createJWT();

      sessionStorage.setItem("JWT_TOKEN", jwt.jwt);

      setUser(loggedUser);
      setRole(userRole);

    } catch (error) {
      console.error("CHECK AUTH ERROR", error);
      setUser(null);
      setRole("");
      sessionStorage.removeItem("JWT_TOKEN");

    } finally {

      setLoading(false);

    }
  };

  const login = async (email, password) => {
    try {
      const session = await account.createEmailPasswordSession(email, password);     
      await checkAuth();
    } catch (error) {
      console.error("LOGIN ERROR", error);
    }
  };

  const logout = async () => {
    try {
      await account.deleteSession("current");
    } catch (error) {
      console.error("LOGOUT ERROR", error);
    }

    sessionStorage.clear();
    setUser(null);
    setRole("");
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        role,
        loading,
        isLoggedIn: !!user,
        login,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);